export enum EmploymentPreferenceTypes {
	DayToDay = "Day To Day",
	LongTerm = "Long Term",
	FixedTerm = "Fixed Term",
	Perm = "Perm",
}
